// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/suplementos-flights/list',
    name: 'suplementos-flights-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/Suplementos.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_suplemento_contrate_fligths',
    },
  },
]

export default formTable
